<template>
  <div class="mb-4">
    <b-alert show variant="warning"><b>Atenção: </b> O controle de permissões agora é feito via Perfis de acesso.
    Alterações de permissão devem ser feitas no perfil de acesso sempre que possível.
    <b>Utilizar esta área somente para exceções.</b></b-alert>
    <div v-for="group in getGroups" :key="group.groupId" class="mb-4">
      <h4 for="group" class="text-left">
        <b-form-checkbox
          @change="checkAllReportsInGroup(group.groupId)"
          :checked="getReports.filter(
            report => report.groupId === group.groupId && report.hasPermission === false
          ).length === 0"
        >
          <strong>{{ group.name }}</strong>
        </b-form-checkbox>
      </h4>
      <div
        v-for="report in getReports.filter(
            report => report.groupId === group.groupId
          )"
        :key="report.reportId"
        class="ml-4"
      >
        <b-form-checkbox
          @change="swapPermission(report)"
          v-model="report.hasPermission"
        >{{ report.name }}</b-form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExtraPermissions",
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  computed: {
    getGroups() {
      return this.$store.getters.getGroups;
    },
    getReports() {
      let reports = this.$store.getters.getReports;
      reports.forEach(report => {
        report.hasPermission = false;
        if (this.customer.extraAuthorities.includes(report.reportId)) {
          report.hasPermission = true;
        }
      });
      return reports;
    }
  },
  methods: {
    swapPermission(report) {
      if (report.hasPermission) {
        this.$store.dispatch("removeExtraAuthority", {
          reportId: report.reportId,
          userId: this.customer.id
        })
        .catch(error => {
          console.error(error);
          this.makeToast('danger', "Não foi possível alterar a permissão");
        });
      } else {
        this.$store.dispatch("addExtraAuthority", {
          reportId: report.reportId,
          userId: this.customer.id
        })
        .catch(error => {
          console.error(error);
          this.makeToast('danger', "Não foi possível alterar a permissão");
        });
      }
    },
    checkAllReportsInGroup(selectedGroupId) {
      this.getReports
        .filter(
          report =>
            report.groupId === selectedGroupId &&
            report.hasPermission === !event.target.checked
        )
        .forEach(report => this.swapPermission(report));
    },
    makeToast(variant = null, content) {
      this.$bvToast.toast(content, {
        title: 'Aviso',
        variant: variant,
        solid: true
      })
    },
  }
};
</script>
